import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function Header({ userLicense, expirationDate }) {
  const navigate = useNavigate()
  const [currNav, setCurrNav] = useState('/')

  useEffect(() => {
    if (window.location.href.includes('/controller')) setCurrNav('controller')
    else if (window.location.href.includes('/objectivesTree')) setCurrNav('objectivesTree')
    else setCurrNav('/')
  }, [window.location.href])

  const onSetCurrPage = (component) => {
    navigate(`/${component}`)
  }

  //capitalizeFirstLetter =.replace(/^./, string[0].toUpperCase())
  userLicense = userLicense?.replace(/^./, userLicense[0]?.toUpperCase()).replaceAll('-', ' ')

  return (
    <nav className="nav-bar">
      <div>
        <Link className={`nav-link ${currNav === '/' && 'current-nav'}`} to="/" onClick={() => onSetCurrPage('')}>
          Create
        </Link>
        <Link className={`nav-link ${currNav === 'controller' && 'current-nav'}`} to="/controller" onClick={() => onSetCurrPage('controller')}>
          Controller
        </Link>
        <Link className={`nav-link ${currNav === 'objectivesTree' && 'current-nav'}`} to="/objectivesTree" onClick={() => onSetCurrPage('objectivesTree')}>
          Objectives Tree
        </Link>
      </div>
      <p>License: {userLicense || '-'} 

      {expirationDate && <span> <span className='seperator'>|</span>Exp. date: {new Date(expirationDate).toLocaleDateString()}</span>}
      </p>
      
    </nav>
  )
}
